module.exports = __webpack_public_path__ + "assets/img/shouye_jiudianyuding-xuanzhong.70883639.svg";